import React, { Component } from 'react';
import autoBind from 'react-autobind';
import _ from 'lodash';
import { Toggle } from 'material-ui';

class BusYieldLegend extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        const stats = {
            totalBuses: 0,
            availableBuses: 0,
        };
        props.detailedOperatorInformation.forEach(info => {
            stats.totalBuses = stats.totalBuses + info.totalBuses;
            stats.availableBuses = stats.availableBuses + info.availableBuses;
        });

        this.state = { stats: stats };
    }

    componentWillReceiveProps(nextProps) {
        const { detailedOperatorInformation } = nextProps;

        if (!_.isEqual(detailedOperatorInformation, this.props.detailedOperatorInformation)) {
            const stats = {
                totalBuses: 0,
                availableBuses: 0,
            };
            detailedOperatorInformation.forEach(info => {
                stats.totalBuses = stats.totalBuses + info.totalBuses;
                stats.availableBuses = stats.availableBuses + info.availableBuses;
            });

            this.setState({ stats: stats });
        }
    }

    render() {
        const { t, busYieldStatistics, operatorCountries, detailedOperatorInformation } = this.props;

        return (
            <legend className="map-legend">
                <span>
                    {t('bus.visible_companies')} {detailedOperatorInformation.length} &nbsp;
                </span>
                <span>
                    {t('bus.active_buses')}: {this.state.stats.availableBuses}
                    &nbsp;
                </span>

                <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }} className="pull-right">
                    <div>
                        <Toggle
                            label={t('bus_yield.filter_unavailable_buses')}
                            labelStyle={{
                                fontSize: '16px',
                                color: '#0c66ab',
                                minWidth: '300px',
                                textAlign: 'right',
                                lineHeight: 'inherit',
                            }}
                            toggled={this.props.showUnavailableBuses}
                            onToggle={this.props.onUnavailableBusesToggle}
                        />
                    </div>
                    <div style={{ display: 'flex', fontsize: 16 }}>
                        <span style={{ fontSize: 16, color: '#0c66ab', paddingRight: '10px', fontWeight: 'bold' }}>
                            {t('bus_yield.filter_by_country')}
                        </span>
                        <select style={{ fontSize: 16 }} onChange={this.props.onCountryChange} defaultValue="">
                            <option style={{ fontSize: 16 }} value="All">
                                All
                            </option>
                            {/* "All" option with an empty value */}
                            {operatorCountries.map(item => (
                                <option key={item} value={item}>
                                    {item}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </legend>
        );
    }
}

export default BusYieldLegend;
